import React,{Component} from 'react';
import LoadProgressIndicator from '../../../Assets/images/ProgressIndicator.gif';

class LoadingIndicator extends Component {
    render(){
        return(
            <div className="LoadProgressIndicator">
                <table style={{width:'100%'}}>
                   <tbody>
                        <tr>
                            <td style={{height:'40px', backgroundColor:'white', textAlign:'center'}}>
                                <img src={LoadProgressIndicator} alt="Loading"/>
                                <label className="ContextText">Loading</label>
                            </td>
                        </tr>
                    </tbody>                                  
                </table>
            </div>
        );
    };
};

export default LoadingIndicator;